<div class="preview-wrapper" [style.backgroundColor]="hexColor">
  <h3 class="abbreviation font-weight-semibold">
    {{ abbreviation }}
  </h3>
  <vdw-pattern class="pattern" [pattern]="pattern"></vdw-pattern>
</div>
